export function validations(state) {
  //@ts-ignore
  if (state.step == 0 && !state.ErgonomieQuestions.Position) return false;
  if (state.step == 0 && !state.ErgonomieQuestions.DominantEye) return false;
  if (state.step == 0 && !state.ErgonomieQuestions.ScreenSize) return false;
  if (state.step == 0 && !state.ErgonomieQuestions.NaturalLight) return false;
  if (state.step == 0 && !state.ErgonomieQuestions.ArtificialLight) return false;
  return true;
}
